import { SidebarAction } from '../interface';
import { SHOW_SIDEBAR } from '../types';

export default function sideBar(isShow: boolean): SidebarAction {
  return {
    type: SHOW_SIDEBAR,
    isShow,
  };
}
